import { gql } from "@apollo/client";

export const UPDATE_ORDER_STATUS = gql`
  mutation UpdateOrderStatus($uuid: String!, $status: String!) {
    update_order_status(uuid: $uuid, status: $status)
  }
`;

export const SAVE_SIGNATURE = gql`
  mutation SaveSignature($signature: String!, $name: String) {
    save_user_provider_signature(signature: $signature, name: $name)
  }
`;

export const UPDATE_AUTO_APPROVE = gql`
  mutation UpdateAutoApprove($autoApproved: Boolean!) {
    update_auto_approved(auto_approved: $autoApproved)
  }
`;

